import { Link } from 'react-router-dom'

import { AuthScreenLayout } from '../components/auth/AuthScreenLayout'
import {
  PERSONAL_DATA_CONSENT_DOCUMENT_VERSION,
  PERSONAL_DATA_CONSENT_OPERATOR,
} from '../legal/personalDataConsent'
import { PRIVACY_POLICY_EXTERNAL_URL } from '../legal/publicOffer'

const op = PERSONAL_DATA_CONSENT_OPERATOR

/** Notice kept at the old URL: cabinet identifies the client as a legal entity. */
export const PersonalDataConsentLegalScreen = () => (
  <AuthScreenLayout variant="register">
    <article className="market-auth__card market-auth__card--register market-legal-doc">
      <header className="market-auth__card-header market-auth__card-header--compact">
        <h1 className="market-auth__card-title market-auth__card-title--compact">
          Данные организации
        </h1>
        <p className="market-auth__card-lead market-auth__card-lead--compact">
          Версия {PERSONAL_DATA_CONSENT_DOCUMENT_VERSION} · {op.sites}
        </p>
      </header>

      <div className="market-legal-doc__body">
        <p>
          Кабинет Provisium работает с клиентом как с юридическим лицом:{' '}
          <strong>ИНН (10 цифр)</strong>, юридическое название, торговое название и корпоративная
          почта. Имя сотрудника, личный телефон и ИНН индивидуального предпринимателя не
          запрашиваем.
        </p>
        <p>
          Исполнитель — {op.legalName} ({op.shortName}), ИНН {op.inn}. Подробности:{' '}
          <a href={PRIVACY_POLICY_EXTERNAL_URL} target="_blank" rel="noopener noreferrer">
            Политика конфиденциальности
          </a>
          .
        </p>
      </div>

      <p className="market-legal-doc__back">
        <Link className="market-auth__signup-link" to="/register">
          ← Вернуться к регистрации
        </Link>
      </p>
    </article>
  </AuthScreenLayout>
)
